async function requestClipboardPermission() {
  if (!navigator.permissions) {
    return 'prompt' // intentar de todos modos
  }

  try {
    const result = await navigator.permissions.query({
      name: 'clipboard-write'
    })
    // Forzar al navegador a mostrar prompt si es posible
    if (result.state === 'granted') {
      return 'granted'
    } else if (result.state === 'prompt') {
      return 'prompt'
    } else {
      throw new Error('Clipboard permission denied')
    }
  } catch (err) {
    return 'prompt' // fallback
  }
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  let successful
  try {
    successful = document.execCommand('copy')
  } catch (err) {
    throw err
  }

  document.body.removeChild(textArea)
  return successful
}

async function copyTextToClipboard(text) {
  const permission = await requestClipboardPermission()

  // Si no existe navigator.clipboard → usar fallback
  if (!navigator.clipboard) {
    if (fallbackCopyTextToClipboard(text)) return
    throw new Error('Copy to Clipboard Error')
  }

  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    throw err
  }
}

export default copyTextToClipboard
